export const toRoundedPhpAmount = (value) => {
  const amount = Number(value ?? 0);
  return Number.isFinite(amount) ? Math.round(amount) : 0;
};

const normalizeTrialMarker = (value) => String(value || '')
  .trim()
  .toUpperCase()
  .replace(/[\s-]+/g, '_');

export const isTrialCard = (card = {}) => {
  const batchType = normalizeTrialMarker(card.batchType || card.originCardBatchType);
  const displayName = String(
    card.trialCard?.displayName
      || card.krialTrial?.displayName
      || card.displayName
      || ''
  ).trim().toLowerCase();

  return Boolean(card.trialCard || card.krialTrial)
    || batchType.includes('KRIAL')
    || batchType === 'TRIAL_CARD'
    || batchType.startsWith('TRIAL_CARD_')
    || displayName === 'trial card';
};

export const getPhysicalCardDisplayBalance = (card = {}) => {
  if (isTrialCard(card)) {
    const trial = card.trialCard || card.krialTrial || {};
    const trialActive = trial.trialActive === true || trial.status === 'trial';
    if (!trialActive) return 0;
    return toRoundedPhpAmount(
      trial.effectiveAmount ?? card.cardBalance ?? card.balance ?? card.initialValue ?? 0
    );
  }
  return toRoundedPhpAmount(card.cardBalance ?? card.balance ?? 0);
};

export const getTrialCardPresentation = (card = {}) => {
  if (!isTrialCard(card)) {
    return {
      isTrialCard: false,
      status: 'notTrial',
      effectiveAmount: getPhysicalCardDisplayBalance(card),
      canLinkToApp: true,
      excludedFromFinance: false,
      daysRemaining: 0
    };
  }

  const trial = card.trialCard || card.krialTrial || {};
  const status = trial.trialActive === true || trial.status === 'trial'
    ? 'active'
    : 'expired';

  return {
    isTrialCard: true,
    status,
    effectiveAmount: status === 'active'
      ? toRoundedPhpAmount(trial.effectiveAmount ?? card.cardBalance ?? card.balance ?? card.initialValue ?? 0)
      : 0,
    canLinkToApp: status !== 'active',
    excludedFromFinance: status === 'active',
    daysRemaining: status === 'active' ? Math.max(Number(trial.daysRemaining) || 0, 0) : 0
  };
};
